import * as D from './deps';

export function getReplayTrack(content) {
  return D.Api.apiRequest({
    endpoint: D.Constants.Api.ApiEndpoints.GET_REPLAY_TRACK,
    content: {
      stationId: content.stationId,
      trackToken: content.trackToken,
      artistUid: content.artistUid,
      // TODO: Why duplicate data
      lastPlayedTrackToken: content.trackToken,
    },
    actionParams: {
      updateEntitiesWith: {
        audioFormat: content.audioFormat,
      },
    },
  });
}

export default {
  getReplayTrack,
};
